<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-12 09:48:05
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div
          :class="pageType === 'output' ? 'type-activite' : ''"
          @click="pageType = 'output'"
        >
          产量
        </div>
        <div
          :class="pageType === 'pondHarvest' ? 'type-activite' : ''"
          @click="pageType = 'pondHarvest'"
        >
          塘口收获情况
        </div>
      </div>
      <!-- 产量 -->
      <OutputPage v-if="pageType === 'output'" />
      <!-- 塘口收获情况 -->
      <PondHarvest v-if="pageType === 'pondHarvest'" />
    </div>
  </div>
</template>

<script>
import OutputPage from "./ym-harvest-output.vue";
import PondHarvest from "./ym-harvest-pond.vue";
export default {
  name: "ym-harvest",
  data() {
    return {
      pageType: "output",
    };
  },
  computed: {},
  methods: {},
  components: {
    OutputPage,
    PondHarvest,
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
</style>